import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Build a Supabase image-transform URL for a public storage object.
 * Falls back to the original URL if it isn't a Supabase public asset.
 * Avoids shipping 1408x1408 avatar PNGs at 36x36.
 */
export function supabaseImage(
  url: string | null | undefined,
  opts: { width: number; height?: number; quality?: number; resize?: "cover" | "contain" | "fill" } = { width: 96 },
): string | undefined {
  if (!url) return undefined;
  if (!url.includes("/storage/v1/object/public/")) return url;
  const transformed = url.replace("/storage/v1/object/public/", "/storage/v1/render/image/public/");
  const params = new URLSearchParams();
  params.set("width", String(opts.width));
  if (opts.height) params.set("height", String(opts.height));
  params.set("quality", String(opts.quality ?? 70));
  params.set("resize", opts.resize ?? "cover");
  return `${transformed}?${params.toString()}`;
}
